import React, { useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Button,
  Stack,
  Skeleton,
  Tooltip,
  IconButton
} from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useDispatch, useSelector } from 'react-redux';
import { deleteTicketPermanently, fetchTicketTrash } from '../../store/features/tickets/ticketsSlice';

const DeletedTicketsDialog = ({ open, onClose }) => {
  const tickets = useSelector((state) => state.ticketTrashSlice.data);
  const isLoading = useSelector((state) => state.ticketTrashSlice.loading);
const dispatch=useDispatch()


useEffect(()=>{
  if(open){
     dispatch(fetchTicketTrash());
  }
},[open])


function handleDeletePermantently(id){

dispatch(deleteTicketPermanently(id))
} 

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>🗑️ Deleted Tickets</DialogTitle>

      <DialogContent dividers sx={{ maxHeight: '65vh', overflowY: 'auto' }}>
        {isLoading ? (
          Array.from({ length: 3 }).map((_, index) => (
            <Box key={index} sx={{ p: 2, mb: 2, borderRadius: 2, backgroundColor: '#f9f9f9' }}>
              <Skeleton variant="text" width="60%" height={28} />
              <Skeleton variant="text" width="90%" />
              <Skeleton variant="text" width="40%" />
              <Skeleton variant="text" width="50%" />
              <Skeleton variant="rectangular" height={36} width={120} sx={{ mt: 1 }} />
            </Box>
          ))
        ) : tickets && tickets.length === 0 ? (
          <Typography align="center" color="textSecondary">
            No deleted tickets.
          </Typography>
        ) : (
          tickets&&tickets.map((ticket, index) => {
            const deletedAt = ticket.statusHistory.find(
              (s) => s.status === 'Deleted'
            )?.changedAt;

            return (
              <Box
                key={index}
                sx={{
                  backgroundColor: '#f9f9f9',
                  borderRadius: 2,
                  mb: 2,
                  p: 2,
                  boxShadow: 1
                }}
              >
                <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                  {ticket.issueTitle} —{' '}
                  <Typography component="span" color="primary">
                    {ticket.ticketId}
                  </Typography>
                </Typography>

                <Stack
                  direction="row"
                  spacing={3}
                  justifyContent="space-between"
                  flexWrap="wrap"
                >
                  {/* Left Side */}
                  <Box flex={1} minWidth="45%">
                    <Typography variant="body2" gutterBottom>
                      <strong>Issue:</strong> {ticket.description}
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      <strong>Priority:</strong> {ticket.priority}
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      <strong>Channel:</strong> {ticket.channel}
                    </Typography>
                  </Box>

                  {/* Right Side */}
                  <Box
                    flex={1}
                    minWidth="45%"
                    textAlign={{ xs: 'left', sm: 'right' }}
                  >
                    <Typography variant="body2" gutterBottom>
                      <strong>Deleted By:</strong> {ticket.isDeletedBy}
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                      <strong>Deleted At:</strong>{' '}
                      {deletedAt ? new Date(deletedAt).toLocaleString() : 'N/A'}
                    </Typography>

                    <Tooltip title="Delete Permanently" onClick={(data)=>handleDeletePermantently(ticket["_id"])}>
                      <IconButton color="error" sx={{ mt: 1 }}>
                        <DeleteForeverIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Stack>
              </Box>
            );
          })
        )}
      </DialogContent>

      <Box display="flex" justifyContent="flex-end" p={2}>
        <Button onClick={onClose} variant="outlined">
          Close
        </Button>
      </Box>
    </Dialog>
  );
};

export default DeletedTicketsDialog;
